'use client'

import { useEffect, useState } from 'react'

import { useTranslations } from '@/lib/next-shim'
import api from '@/lib/api'
import { OtpVerificationDialog } from '@/shared/ui/dialog/OtpVerificationDialog'

import { ChangePasswordDialog } from './ChangePasswordDialog'

type Props = {
  open: boolean
  onClose: () => void
  onConfirmed: () => void
}

export function PasswordChangeOtpDialog({ open, onClose, onConfirmed }: Props) {
  const t = useTranslations('component.passwordChangeOtpDialog')
  const [step, setStep] = useState<'otp' | 'password'>('otp')

  useEffect(() => {
    if (!open) setStep('otp')
  }, [open])

  return (
    <>
      <OtpVerificationDialog
        open={open && step === 'otp'}
        onClose={onClose}
        onVerified={() => setStep('password')}
        onSendOtp={async (resend) => {
          try {
            await api.auth.sendPasswordChangeOtp(resend)
            return true
          } catch {
            return false
          }
        }}
        onVerifyOtp={async (otp) => {
          try {
            return await api.auth.verifyPasswordChangeOtp(otp)
          } catch {
            return false
          }
        }}
        title={t('title.otp')}
        description={t('otp.description')}
        sentInfo={t('messages.codeSent')}
        sendError={t('errors.sendCode')}
        verifyError={t('errors.invalidOtp')}
        resendLabel={t('actions.resendCode')}
        cancelLabel={t('actions.cancel')}
        confirmLabel={t('actions.continue')}
        closeLabel={t('actions.close')}
      />
      <ChangePasswordDialog
        open={open && step === 'password'}
        onClose={onClose}
        onSubmit={async (password) => {
          try {
            await api.auth.changePassword(password)
            onConfirmed()
            return true
          } catch {
            return false
          }
        }}
      />
    </>
  )
}
